module.exports = __webpack_public_path__ + "224a95c2ca202d37049e5fb1ef7a3f5a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_3_0.woff
// module id = 2254
// module chunks = 2